import { selector } from 'recoil';
import axios from '../../common/axiosInterceptor';
import { startingDate } from '../atoms/startingDate';
import { endingDate } from '../atoms/endingDate';
import event from '../events/businessNumberReporting';
import { user } from '../atoms/user';
export const businessNumberReporting = selector({
  key: 'businessNumberReporting',
  get: async ({ get }) => {
    try {
      const storageUser = get(user);
      const start = get(startingDate);
      const end = get(endingDate);

      event.businessid = storageUser.businessid;
      event.apiKey = storageUser.apikey;
      event.startdate = start;
      event.enddate = end;
      const result = await axios.post(
        `${process.env.VITE_APP_API_DOMAIN}/${process.env.VITE_APP_API_STAGE}/getbusinessnumberreporting`,
        JSON.stringify(event)
      );
      // console.log(
      //   JSON.stringify(result, null, 2),
      //   "current-----0-0-0-0-0-00---0-0-0"
      // );
      return result;
    } catch (error) {
      throw error;
    }
  },
});
